export enum Xrp2iEventType {
  SCAN,
  INVALID_EID,
  ERROR,
  TIME_SYNCED,
}

export interface Xrp2iScanEvent {
  type: Xrp2iEventType.SCAN;
  eid: string;
  created: string;
}

export interface Xrp2iInvalidEidEvent {
  type: Xrp2iEventType.INVALID_EID;
}

export interface Xrp2iErrorEvent {
  type: Xrp2iEventType.ERROR;
  code: string;
}

export interface Xrp2iTimeSyncedEvent {
  type: Xrp2iEventType.TIME_SYNCED;
  /** Milliseconds the device clock lagged behind system time before correction (negative means device was ahead). */
  driftMs: number;
}

export type Xrp2iEvent =
  | Xrp2iScanEvent
  | Xrp2iInvalidEidEvent
  | Xrp2iErrorEvent
  | Xrp2iTimeSyncedEvent;

export type Xrp2iDeviceEventHandler = (event: Xrp2iEvent) => void;

export interface Xrp2iDeviceHandle {
  resetHardwareConfig(): Promise<void>;
  setDeviceTime(): void;
  destroy(): void;
}

export enum DeviceMode {
  IDLE,
  AWAITING_LINE_ENDINGS_STATE,
  AWAITING_EID_OUTPUT_FORMAT,
  AWAITING_DEVICE_DATE,
  AWAITING_DEVICE_TIME,
}
